/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdeletionnotavailable3Inputs */

const en_accountdeletionnotavailable3 = /** @type {(inputs: Accountdeletionnotavailable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account deletion is not available yet.`)
};

const de_accountdeletionnotavailable3 = /** @type {(inputs: Accountdeletionnotavailable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontolöschung ist noch nicht verfügbar.`)
};

/**
* | output |
* | --- |
* | "Account deletion is not available yet." |
*
* @param {Accountdeletionnotavailable3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountdeletionnotavailable3 = /** @type {((inputs?: Accountdeletionnotavailable3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdeletionnotavailable3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdeletionnotavailable3(inputs)
	return de_accountdeletionnotavailable3(inputs)
});
export { accountdeletionnotavailable3 as "accountDeletionNotAvailable" }